import type { HttpTransport } from "@common/api/transport";
import type { WorkflowTemplate } from "@common/types";

export const createWorkflowTemplatesApi = (http: HttpTransport) => ({
  destroyWorkflowTemplate: (id: number) =>
    fetch(`/api/workflow_templates/${id}`, { method: "DELETE" }),

  fetchWorkflowTemplates: () => http.get<WorkflowTemplate[]>("/api/workflow_templates")
});
